export interface ContactForm {}

export const initialContactFormState = (): ContactForm => ({});
